import React, { useCallback, useEffect, useState } from "react";
import {
  Form,
  // Modal,
  Button,
  Col,
  InputGroup,
  FormControl,
  Offcanvas,
  Tabs,
  Tab,
  Row,
} from "react-bootstrap";
import { withCookies } from "react-cookie";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  addTask,
  updateTask,
  archiveTask,
  unArchiveTask,
} from "../../redux/actions/tasks";
import configVars from "../../config";
import AllComments from "../Comments/AllComments";
import History from "../History";

// Images
import noCommentImg from "../../images/noComment.png";
import PromptBox from "../PromptBox";
const ActionPlan = ({
  setApiLoading,
  show,
  handleClose,
  selectedTask,
  board,
  columnId,
  selectedColumn,
  droppableColumn,
  config,
  draggableColumn,
  handleArchive,
  handleUnarchive,
  handleDelete,
  columnTitle,
  getColumnNo,
  setShowCloseConfirmation,
  resetInitially = false,
  showArchiveButtons = true,
}) => {
  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");

  const allTaskTypes = config && config["task_type"];
  const allTaskStatus = config && config["task_status"];
  const params = useParams();
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [showUpdateBtn, setShowUpdateBtn] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [displayPrompt, setDisplayPrompt] = useState(false);
  const [factors, setFactors] = useState("");
  const [factorsContentState, setFactorsContentState] = useState("");
  const [action, setAction] = useState("");
  const [actionContentState, setActionContentState] = useState("");
  const [taskType, setTaskType] = useState(
    allTaskTypes ? Object.keys(allTaskTypes)[0] : null
  );
  const [status, setStatus] = useState("");
  const [showClearStatus, setShowClearStatus] = useState(false);
  const [timeline, setTimeline] = useState({
    startDate: selectedTask?.action_plan_timeline_start
      ? moment(new Date(selectedTask?.action_plan_timeline_start)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
    endDate: selectedTask?.action_plan_timeline_end
      ? moment(new Date(selectedTask?.action_plan_timeline_end)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
  });
  const [loading, setLoading] = useState(false);
  const [datePickerKey, setDatePickerKey] = useState(0);
  const allComments = selectedTask?.comments ? selectedTask.comments : [];
  const resetState = useCallback(() => {
    setTitle({ value: "", error: false });
    setFactors(null);
    setAction(null);
    setFactorsContentState(null);
    setActionContentState(null);
    setUsers([]);
    setTaskType(allTaskTypes ? Object.keys(allTaskTypes)[0] : null);
    setStatus("");
    setTimeline({});
  }, [allTaskTypes]);

  useEffect(() => {
    setFactors(null);
    setAction(null);
    setFactorsContentState(null);
    setActionContentState(null);
  }, [selectedTask]);

  useEffect(() => {
    if (resetInitially) {
      resetState();
    }
  }, [show, resetInitially, resetState]);

  useEffect(() => {
    if (selectedTask) {
      setTimeline((tl) => ({
        ...tl,
        startDate: selectedTask?.action_plan_timeline_start
          ? moment(new Date(selectedTask?.action_plan_timeline_start)).format(
              "MM/DD/YYYY"
            )
          : moment(new Date()).format("MM/DD/YYYY"),
        endDate: selectedTask?.action_plan_timeline_end
          ? moment(new Date(selectedTask?.action_plan_timeline_end)).format(
              "MM/DD/YYYY"
            )
          : moment(new Date()).format("MM/DD/YYYY"),
      }));
      setDatePickerKey((k) => k + 1);
      setTitle({ value: selectedTask.title, error: false });

      let _factorDesc = null;
      if (selectedTask?.idea_bank_factor_description) {
        _factorDesc = selectedTask?.idea_bank_factor_description;
      } else if (selectedTask?.current_situation_factor_description) {
        _factorDesc = selectedTask?.current_situation_factor_description;
      } else if (selectedTask?.action_plan_factor_description) {
        _factorDesc = selectedTask?.action_plan_factor_description;
      }

      if (_factorDesc) {
        const contentBlock1 = htmlToDraft(_factorDesc);

        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setFactors(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setFactorsContentState(_contentState);
        } else {
          setFactors(null);
          setFactorsContentState(null);
        }
      }

      let _decidedAction = null;
      if (selectedTask?.action_plan_decided_action) {
        _decidedAction = selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        _decidedAction = selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        _decidedAction = selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        _decidedAction = selectedTask?.evaluation_result;
      }

      if (_decidedAction) {
        const contentBlock2 = htmlToDraft(_decidedAction);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setActionContentState(_contentState);
          setAction(editorState);
        } else {
          setAction(null);
          setActionContentState(null);
        }
      }
      if (selectedTask?.responsible_persons) {
        setUsers(selectedTask?.responsible_persons);
      }
      setStatus(selectedTask?.task_status?.term_id);
      setTaskType(selectedTask?.task_type?.term_id);
    }
  }, [selectedTask, show]);
  useEffect(() => {
    if (board) {
      setAllUsers(board?.associated_users);
    }
  }, [board]);

  const handleChange = (value, field) => {
    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
    if (setShowCloseConfirmation) {
      setShowCloseConfirmation(true);
    }
    if (field === "title") {
      setTitle({ value: value, error: false });
    } else if (field === "factors") {
      setFactors(value);
    } else if (field === "action") {
      setAction(value);
    }
  };

  const handleSubmit = async (action, archive) => {
    if (!title?.value) {
      setTitle({ ...title, error: true });
      return;
    }

    let selectedUsers = [];
    users && users.forEach((user) => selectedUsers.push(user.id));
    try {
      setLoading(true);
      let tasklist_id = droppableColumn
        ? droppableColumn
        : selectedColumn
        ? selectedColumn
        : columnId
        ? columnId
        : null;

      let taskObject = {
        board_id: parseInt(params?.board_id),
        title: title?.value,
        tasklist_id: tasklist_id ? parseInt(tasklist_id) : null,
        action_plan_factor_description: draftToHtml(factorsContentState),
        action_plan_decided_action: draftToHtml(actionContentState),
        action_plan_timeline_start: moment(timeline?.startDate).format(
          "YYYY/MM/DD"
        ),
        action_plan_timeline_end: moment(timeline?.endDate).format(
          "YYYY/MM/DD"
        ),
        task_type: taskType,
        task_status: status,
        task_responsible_person: selectedUsers,
        post_status: "publish",
      };

      if (action === "create") {
        taskObject["parent_task_id"] = selectedTask?.id
          ? selectedTask?.id
          : null;
        await dispatch(
          addTask({
            data: taskObject,
            columnId: droppableColumn ? droppableColumn : columnId,
          })
        );
        if (archive) {
          let archiveTaskObject = {
            id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
            post_status: "archive",
          };

          await dispatch(
            archiveTask({
              data: archiveTaskObject,
              columnId: draggableColumn,
              task: selectedTask,
            })
          );
        }
      } else {
        if (selectedColumn) {
          if (!taskObject.action_plan_factor_description) {
            delete taskObject["action_plan_factor_description"];
          }
          if (!taskObject.action_plan_decided_action) {
            delete taskObject["action_plan_decided_action"];
          }

          taskObject["id"] = selectedTask?.id;
          if (!taskObject["board_id"]) {
            taskObject["board_id"] = selectedTask["board_id"];
          }

          await dispatch(
            updateTask({ data: taskObject, columnId: selectedColumn })
          );
        }
      }
      resetState();
      setLoading(false);
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setDisplayPrompt(false);
      handleClose(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDateRange = (start, end, label) => {
    setTimeline({
      startDate: start.format("MM/DD/YYYY"),
      endDate: end.format("MM/DD/YYYY"),
    });
    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
  };
  const handleArchiveCard = async () => {
    try {
      setLoading(true);

      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "archive",
      };
      await dispatch(
        archiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      setLoading(false);
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const handleUnarchiveCard = async () => {
    try {
      setLoading(true);
      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "publish",
      };
      await dispatch(
        unArchiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      setLoading(false);
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };

  const _handleCloseLocal = () => {
    if (showUpdateBtn || showSaveBtn) {
      setDisplayPrompt(true);
    } else {
      setDisplayPrompt(false);
      handleClose();
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        _handleCloseLocal();
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      fullscreen={"sm-down"}
      backdrop
      style={{ margin: "0rem", width: "70%" }}
      placement="end"
    >
      <Offcanvas.Header className="p-1" closeButton>
        <Offcanvas.Title className="font-weight-bold" style={{ width: "100%" }}>
          <Col
            lg="6"
            className="d-flex justify-content-between align-item-center m-2"
          >
            <h3 className="d-flex mb-0 align-items-center">
              <span className="d-flex align-items-center mx-2  justify-content-center  text-white title-number-background bg-action-blue">
                3
              </span>
              {columnTitle}
            </h3>
            {showSaveBtn && !selectedTask ? (
              <Button
                style={{
                  height: "43px",
                  fontSize: "13px",
                  borderRadius: "32px",
                }}
                variant="action-blue text-white rounded px-3 mx-3"
                onClick={() => handleSubmit("create")}
                disabled={loading}
                className="save-new-card"
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.save")
                )}
              </Button>
            ) : null}
            {showUpdateBtn && selectedTask && !droppableColumn ? (
              <Button
                style={{
                  height: "32px",
                  padding: "0px 0px",
                  fontSize: "13px",
                }}
                variant="action-blue text-white rounded"
                onClick={() => handleSubmit("update")}
                className="mx-3 px-3 pull-right update-selected"
                disabled={loading}
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.update")
                )}
              </Button>
            ) : null}
          </Col>
          <Col lg="6" md="12" />
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 action-plan">
        {setApiLoading ? (
          <div className="container-fluid px-3">
            <div className="d-flex justify-content-center mt-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </div>
        ) : (
          <Row>
            <Col
              lg="6"
              md="12"
              style={{
                overflowY: "scroll",
                height: "100vh",
              }}
            >
              <Form>
                <div className="">
                  <div className="d-lg-flex flex-lg-column">
                    <Form.Group className="mb-2 pt-2">
                      <Form.Label>
                        <b className="text-capitalize">
                          {translation("task_forms.action_plan.field1.label")}
                        </b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={translation(
                          "task_forms.action_plan.field1.placeholder"
                        )}
                        value={title?.value
                          ?.substring(0, 45)
                          .replaceAll("&amp;", "&")}
                        onChange={(e) => handleChange(e.target.value, "title")}
                        isInvalid={title?.error}
                        style={{
                          fontSize: "14px",
                          padding: "0.5rem 0.5rem",
                          borderRadius: "0px",
                        }}
                      />
                      {title?.error && (
                        <Form.Control.Feedback type="invalid">
                          {translation("task_forms.action_plan.field1.error")}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                    {/* bootstrap class for margin top not executing here */}
                    <Form.Group
                      style={{
                        marginTop: "10px",
                        width: "100%",
                      }}
                    >
                      <Form.Label>
                        <b>
                          {translation("task_forms.action_plan.field2.label")}
                        </b>
                      </Form.Label>
                      <Typeahead
                        id="basic-typeahead-multiple"
                        labelKey="display_name"
                        selected={users}
                        defaultSelected={[]}
                        multiple
                        onChange={(e) => {
                          setUsers(e);
                          if (setShowCloseConfirmation) {
                            setShowCloseConfirmation(true);
                            setShowUpdateBtn(true);
                          }
                        }}
                        options={allUsers}
                        placeholder={translation(
                          "task_forms.action_plan.field2.placeholder"
                        )}
                        className="responsible-users"
                        inputProps={{
                          className: "custom-user-input",
                        }}
                      />
                    </Form.Group>
                  </div>

                  <div>
                    <div className="d-flex justify-content-center">
                      {config &&
                        allTaskTypes &&
                        Object.keys(allTaskTypes)?.map((item, index) => {
                          return (
                            <Col className="d-flex px-2" key={index}>
                              <Button
                                variant={
                                  parseInt(taskType) === parseInt(item)
                                    ? "action-blue"
                                    : "outline-action-blue"
                                }
                                className={`${
                                  parseInt(taskType) === parseInt(item)
                                    ? `text-white`
                                    : `text-black`
                                } rounded`}
                                style={{
                                  width: "100%",
                                  textTransform: "uppercase",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setTaskType(item);
                                }}
                              >
                                {allTaskTypes[item]?.name}
                              </Button>
                            </Col>
                          );
                        })}
                    </div>

                    <div className="d-flex justify-content-center mt-4">
                      <InputGroup className="mb-2">
                        <Form.Label style={{ width: "100%" }}>
                          <b>
                            {translation("task_forms.action_plan.field3.label")}
                          </b>
                        </Form.Label>
                        <InputGroup.Text>
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                        </InputGroup.Text>
                        <DateRangePicker
                          key={datePickerKey}
                          onCallback={handleDateRange}
                          initialSettings={timeline}
                          onApply={() => {
                            if (setShowCloseConfirmation) {
                              setShowCloseConfirmation(true);
                            }
                          }}
                        >
                          <FormControl
                            style={{ borderRadius: "0px" }}
                            type="text"
                            placeholder={translation("add_time_period")}
                          />
                        </DateRangePicker>
                      </InputGroup>
                    </div>
                  </div>
                </div>

                <div className="d-flex mt-3">
                  <Form.Label>
                    <div className="d-flex">
                      <div className="col">
                        <b>{translation("task_forms.action_plan.field4.label")}</b>
                      </div>
                      {showClearStatus &&
                        <div className="col-auto">
                          <button type="button" className="btn btn-link py-0 text-action-blue ms-3 font-size-medium" onClick={() => {setShowClearStatus(false);setStatus('');}}>
                            <i className="fa fa-trash"></i>
                            <span className="ps-2">Tömma <span className="text-lowercase">{translation("task_forms.action_plan.field4.label")}</span></span>
                          </button>
                        </div>
                      }
                    </div>
                    
                  </Form.Label>
                </div>
                <div className="d-flex justify-content-left mb-3">
                  {config &&
                    allTaskStatus &&
                    Object.keys(allTaskStatus)?.map((item, index) => {
                      return (
                        <div className="" key={index}>
                          <button
                            style={{
                              height: "32px",
                              width: "90px",
                              padding: "0px 0px",
                              fontSize: "13px",
                              borderRadius: "32px",
                              marginRight: "10px",
                            }}
                            type="button"
                            className={` btn border-1 ${
                              status === allTaskStatus[item].term_id
                                ? `btn-sy-${allTaskStatus[item].slug} text-white`
                                : `btn-outline-sy-${allTaskStatus[item]?.slug}`
                            }`}
                            onClick={() => {
                              setStatus(allTaskStatus[item].term_id);
                              if (setShowCloseConfirmation) {
                                setShowUpdateBtn(true);
                                setShowCloseConfirmation(true);
                                setShowClearStatus(true);
                              }
                            }}
                          >
                            {allTaskStatus[item]?.name}
                          </button>
                        </div>
                      );
                    })}
                </div>

                <Form.Group>
                  <Form.Label>
                    <b>{translation("task_forms.action_plan.field5.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={factors}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "factors")}
                    onChange={(e) => {
                      setFactorsContentState(e);
                    }}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>
                    <b>{translation("task_forms.action_plan.field6.label")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={action}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => handleChange(e, "action")}
                    onChange={(e) => {
                      setActionContentState(e);
                    }}
                  />
                </Form.Group>
              </Form>
              <div>
                {selectedTask && droppableColumn ? (
                  <Row>
                    <div className="me-5 task-moved">
                      <Button
                        variant="action-blue text-white rounded px-3"
                        onClick={() => handleSubmit("create", false)}
                        disabled={loading}
                        className="mb-2"
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text3"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>
                      <Button
                        variant="action-blue text-white rounded"
                        onClick={() => handleSubmit("create", true)}
                        disabled={loading}
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text4"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>
                    </div>
                  </Row>
                ) : selectedTask && selectedColumn ? (
                  <div
                    className="d-flex justify-content-left task-btns"
                    style={{ width: "100%" }}
                  >
                    <div className="update-exist">
                      <Button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          marginRight: "10px",
                        }}
                        variant="action-blue text-white rounded px-3"
                        onClick={() => handleSubmit("update")}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.update")
                        )}
                      </Button>
                    </div>
                    <div className="archive-delete">
                      {selectedTask?.post_status === "publish" &&
                      showArchiveButtons ? (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            marginRight: "10px",
                          }}
                          variant="action-blue text-white rounded px-3"
                          onClick={() => {
                            handleArchiveCard();
                          }}
                          className="archive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.archive_card")
                          )}
                        </Button>
                      ) : showArchiveButtons ? (
                        <Button
                          variant="action-blue text-white rounded px-3"
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            marginRight: "10px",
                          }}
                          onClick={() => {
                            handleUnarchiveCard();
                          }}
                          className="unarchive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.unarchive_card")
                          )}
                        </Button>
                      ) : (
                        <></>
                      )}
                      <Button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          marginRight: "10px",
                        }}
                        variant="action-blue text-white rounded px-3"
                        onClick={() => handleDelete()}
                        className="delete-card"
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.delete_card")
                        )}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <Button
                    style={{
                      height: "43px",
                      fontSize: "13px",
                      borderRadius: "32px",
                      marginRight: "10px",
                    }}
                    variant="action-blue text-white rounded px-3"
                    onClick={() => handleSubmit("create")}
                    disabled={loading}
                    className="save-card"
                  >
                    {loading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      translation("buttons.save")
                    )}
                  </Button>
                )}
              </div>
            </Col>
            <Col className="p-0" lg="6" md="12">
              {!selectedTask ? (
                <div className="d-flex justify-content-center align-items-center h-100 new-card-comment">
                  <img
                    src={noCommentImg}
                    alt="No-Comments"
                    style={{ width: "200px" }}
                  />
                </div>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey="commentsKey"
                    id="uncontrolled-tab-example"
                    className="mb-3 sustain-tabs bg-white"
                    fill
                  >
                    <Tab
                      eventKey="commentsKey"
                      title={translation("task_forms.comments.commentsHeading")}
                    >
                      {/* <div className="col-md-12 col-xs-12"> */}
                      {selectedTask && droppableColumn ? (
                        <div className="d-flex justify-content-center align-items-center no-comments-container">
                          <img
                            src={noCommentImg}
                            alt="No-Comments"
                            style={{ width: "200px" }}
                          />
                        </div>
                      ) : (
                        <AllComments
                          task_id={selectedTask?.id}
                          color="action-blue"
                          taskComments={allComments}
                          tasklist_id={
                            columnId
                              ? columnId
                              : droppableColumn
                              ? droppableColumn
                              : selectedColumn
                              ? selectedColumn
                              : null
                          }
                        />
                      )}
                      {/* </div> */}
                    </Tab>
                    <Tab eventKey="history" title={translation("history")}>
                      <div className="col-12 px-2">
                        <History
                          taskDate={selectedTask.task_date}
                          history={selectedTask?.history}
                          getColumnNo={getColumnNo}
                          config={config}
                          board={board}
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </>
              )}
            </Col>
            <PromptBox
              show={displayPrompt}
              handleClosePrompt={() => {
                setShowCloseConfirmation(false);
                setShowUpdateBtn(false);
                setShowSaveBtn(false);
                setTimeout(() => {
                  setDisplayPrompt(false);
                  handleClose();
                }, 100);
              }}
              title={translation("changes_not_saved")}
              message={translation("select_changes")}
              handleClose={() => {
                setDisplayPrompt(false);
              }}
              handleSave={() => {
                if (selectedTask) {
                  handleSubmit("update");
                } else {
                  handleSubmit("create");
                }
                setShowUpdateBtn(false);
              }}
              isLoading={loading}
            />
          </Row>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default withCookies(ActionPlan);
